<template>
  <div class="return-depot-list">
    <div class="intro-text">
      <h1>Closest depots</h1>
      <p>
        You can hand the vehicle in at the depot where you picked it up at no
        charge.
      </p>
    </div>

    <div class="rr-list">
      <div
        v-for="depot in depots"
        v-bind:key="depot.id"
        @click="handleDepotClicked(depot)"
        :id="`depot-item-${depot.id}`"
        :class="{
          'selected-depot': selectedDepot && selectedDepot.id === depot.id
        }"
      >
        <DepotInfoItem
          :model="depot"
          :selectedDepot="selectedDepot"
          class="p-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DepotInfoItem from "@/components/crud/depot/partials/DepotInfoItem";

export default {
  name: "return-locations-depot-list",
  props: ["depots", "selectedDepot"],
  components: {
    DepotInfoItem
  },
  methods: {
    handleDepotClicked(depot) {
      this.$emit("depot-clicked", depot);
    }
  },
  watch: {
    selectedDepot: function(newVal) {
      if (!newVal) {
        return;
      }

      const el = document.getElementById(`depot-item-${newVal.id}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }
};
</script>

<style>
.return-depot-list .company {
  background: transparent !important;
}
</style>
